module.exports = __webpack_public_path__ + "img/box.e818b411.svg";